<section class="screen-saver">
    <div class="screen-saver--header">
        <img src="assets/images/screen-saver-logo.svg"
             class="logo best-fit"
             alt="SalesRun Logo">
    </div>
    <div class="screen-saver--content">

        <div class="screen-saver--content--message entity-not-found">
            <p>Your link is no longer valid.</p>
            <p>Please contact your Administrator to renew it.</p>
        </div>

        <div class="flex-padding"></div>
    </div>
    <div class="screen-saver--footer">
        <span class="copyright">
            SalesRun v5.0 - All Rights Reserved
        </span>
    </div>
</section>